import { FieldSpan, LayoutSettings, TextScale } from '../types/highlights'

interface TextScaleStyle {
  label: string
  height: string
  labelText: string
  valueText: string
  padding: string
  flagText: string
}

export const textScaleStyles: Record<TextScale, TextScaleStyle> = {
  sm: {
    label: 'Small',
    height: 'h-[40px]',
    labelText: 'text-[9.5px]',
    valueText: 'text-[12px]',
    padding: 'pl-2 pr-1',
    flagText: 'text-[9.5px]',
  },
  md: {
    label: 'Medium',
    height: 'h-[46px]',
    labelText: 'text-[10.5px]',
    valueText: 'text-[13px]',
    padding: 'pl-2.5 pr-1.5',
    flagText: 'text-[10.5px]',
  },
  lg: {
    label: 'Large',
    height: 'h-[54px]',
    labelText: 'text-[11px]',
    valueText: 'text-[15px]',
    padding: 'pl-3 pr-2',
    flagText: 'text-[11px]',
  },
}

export const textScaleOrder: TextScale[] = ['sm', 'md', 'lg']

export const columnWidthOptions: { label: string; value: number }[] = [
  { label: 'Compact', value: 170 },
  { label: 'Standard', value: 210 },
  { label: 'Wide', value: 260 },
]

export const spanOptions: { label: string; value: FieldSpan }[] = [
  { label: 'Auto', value: 'auto' },
  { label: '1×', value: 1 },
  { label: '2×', value: 2 },
  { label: '3×', value: 3 },
]

export const defaultLayout: LayoutSettings = {
  uniformSizing: false,
  columnWidth: 210,
  textScale: 'md',
}

/** Columns a field needs when its width is set to Auto, based on value length. */
export function autoSpan(characters: number): 1 | 2 | 3 {
  if (characters <= 20) return 1
  if (characters <= 36) return 2
  return 3
}

export function resolveSpan(
  span: FieldSpan | undefined,
  valueLength: number,
  layout: LayoutSettings,
): 1 | 2 | 3 {
  if (layout.uniformSizing) return 1
  if (span === undefined || span === 'auto') return autoSpan(valueLength)
  return span
}

export function truncateValue(value: string, maxChars?: number): string {
  if (!maxChars || maxChars <= 0 || value.length <= maxChars) return value
  return `${value.slice(0, maxChars).trimEnd()}…`
}
